import { AdminUsersService } from './adminUsersService';
import { PermissionsService } from './permissionsService';
import { RolesAndPermissionsService } from './rolesAndPermissionsService';
import { UserService } from './userservice';

const ROLE_CAPABILITIES: Record<
  string,
  {
    canViewRoles: boolean;
    canViewPermissions: boolean;
    canViewAdminUsers: boolean;
  }
> = {
  Superadmin: {
    canViewRoles: true,
    canViewPermissions: true,
    canViewAdminUsers: true,
  },
  Admin: {
    canViewRoles: true,
    canViewPermissions: true,
    canViewAdminUsers: false,
  },
};

const NO_CAPABILITIES = {
  canViewRoles: false,
  canViewPermissions: false,
  canViewAdminUsers: false,
};

export const SessionService = {
  async init(currentRoles: string[]) {
    const caps = currentRoles.reduce(
      (merged, roleName) => {
        const roleCaps = ROLE_CAPABILITIES[roleName] ?? NO_CAPABILITIES;
        return {
          canViewRoles: merged.canViewRoles || roleCaps.canViewRoles,
          canViewPermissions: merged.canViewPermissions || roleCaps.canViewPermissions,
          canViewAdminUsers: merged.canViewAdminUsers || roleCaps.canViewAdminUsers,
        };
      },
      { ...NO_CAPABILITIES },
    );

    const calls: Record<string, Promise<any>> = {
      navigationItems: UserService.retrieveNavigationItems(),
    };

    if (caps.canViewRoles) {
      calls.rolesAndPermissions = RolesAndPermissionsService.getAllRoles();
    }

    if (caps.canViewPermissions) {
      calls.permissions = PermissionsService.getAllPermissions();
    }

    if (caps.canViewAdminUsers) {
      calls.adminUsers = AdminUsersService.getAdminUsers();
    }

    const entries = Object.entries(calls);
    const settled = await Promise.allSettled(entries.map(([, promise]) => promise));

    const results: Record<string, any> = {};
    settled.forEach((result, index) => {
      const [key] = entries[index];
      if (result.status === 'fulfilled') {
        results[key] = result.value;
      } else {
        console.error(`SessionService.init: failed to load "${key}"`, result.reason);
      }
    });

    return results;
  },
};
